export const LOCAL_ROOT = 'http://localhost:3000';

export const INVITE_API_MIRAGE_ROOT_URL = '/inviteservice';
export const PERMISSION_API_MIRAGE_ROOT_URL = '/permissionservice';

export const shouldUseMirage =
  process.env.JEST_WORKER_ID !== undefined ||
  "development" === 'mirage-development';

export const BASE_API_URL = shouldUseMirage
  ? ''
  : `https://${"staging.accounts.cropwise.com"}/v2`;

export const CROPWISE_PROXY_URL = shouldUseMirage
  ? ''
  : `${"https://api-dev.financials.cropwise.com"}/api`;

export const CROPWISE_PROXY_V2_URL = shouldUseMirage
  ? ''
  : `${"https://api-v2-dev.financials.cropwise.com"}`;

export const CROPWISE_MASTERDATA = shouldUseMirage
  ? ''
  : `${"https://api-dev.financials.cropwise.com"}/masterdata/api/v1`;

export const MASTERLIST_PROXY_URL = shouldUseMirage
  ? ''
  : "https://masterlist-proxy-api.landdb.com/api";

export const MOCK_API_URL = '';

export const INVITE_API_URL = INVITE_API_MIRAGE_ROOT_URL;

export const PERMISSION_API_URL = shouldUseMirage
  ? PERMISSION_API_MIRAGE_ROOT_URL
  : undefined;

export const MASTERLIST_CROPS_URL = shouldUseMirage
  ? ''
  : `https://${"staging.accounts.cropwise.com"}/v2`;

export const API_CROPS_LIST = shouldUseMirage
  ? ''
  : `https://${"api.staging.base.cropwise.com"}/v2`;

export const AG_CLEAR_APP_URL = `${undefined}/v1.1`;
